const ActivityProgressSection = () => {
    return (
        <section className="basic-area progress-area">
            <div className="container">
                <div className="basic-flex basic-flex--reverse progress">
                    <img
                        className="basic-flex__image"
                        src="/images/profile.gif"
                        alt="progress"
                    />

                    <div className="basic-flex__content">
                        <h2>
                            Keep track of your progress over time and unlock new
                            levels as you get better.
                        </h2>

                        <div>
                            Unlock new levels that include advanced questions and categories when you get the basics right.
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ActivityProgressSection;
